import React, { useEffect, useState } from 'react';
import AddProductDialog from '../../dialogs/AddProductDialog';
import ContactUsDialog from '../../dialogs/ContactUsDialog';
import ProductDetailDialog from '../../dialogs/ProductDetailDialog';
import AddToRoutineDialog from '../../dialogs/AddToRoutineDialog';
import CreateRoutineDialog from '../../dialogs/CreateRoutineDialog';
import TermsDialog from '../../dialogs/TermsDialog';
import PrivacyDialog from '../../dialogs/PrivacyDialog';
import AddProductBottomSheet from '../../bottomdrawers/AddProductBottomSheet';
import ContactUsBottomSheet from '../../bottomdrawers/ContactUsBottomSheet';
import ProductDetailBottomSheet from '../../bottomdrawers/ProductDetailBottomSheet';
import AddToRoutineBottomSheet from '../../bottomdrawers/AddToRoutineBottomSheet';
import CreateRoutineBottomSheet from '../../bottomdrawers/CreateRoutineBottomSheet';
import TermsBottomSheet from '../../bottomdrawers/TermsBottomSheet';
import PrivacyBottomSheet from '../../bottomdrawers/PrivacyBottomSheet';
import ActiveIngredientsDialog from '../../dialogs/ActiveIngredientsDialog';
import ActiveDetailDialog from '../../dialogs/ActiveDetailDialog';
import ActiveDetailBottomSheet from '../../bottomdrawers/ActiveDetailBottomSheet';
import ActiveIngredientsBottomSheet from '../../bottomdrawers/ActiveIngredientsBottomSheet';

// Mobile breakpoint
const MOBILE_BREAKPOINT = 768;

interface ResponsiveDialogProps {
  type: 'addProduct' | 'contactUs' | 'productDetail' | 'addToRoutine' | 'createRoutine' | 'terms' | 'privacy' | 'activeIngredients' | 'activeDetail';
  isOpen: boolean;
  onClose: () => void;
  // AddProduct props
  onAddProduct?: (productId: number) => void;
  // ContactUs props
  onSend?: (message: string) => void;
  // ProductDetail props
  onBack?: () => void;
  product?: any;
  onAddProductToCabinet?: (productId: number) => void;
  // AddToRoutine props
  routineType?: 'AM' | 'PM';
  selectedDay?: string;
  currentRoutineProducts?: any[];
  userId?: number;
  onAddAction?: (actionId: string) => void;
  // CreateRoutine props
  onCreateRoutine?: (routineType: any) => void;
  // ActiveIngredients props
  onActiveClick?: (active: any) => void;
  // ActiveDetail props
  activeId?: string;
  onActiveDetailBack?: () => void;
}

const ResponsiveDialog: React.FC<ResponsiveDialogProps> = ({
  type,
  isOpen,
  onClose,
  onAddProduct,
  onSend,
  onBack,
  product,
  onAddProductToCabinet,
  routineType,
  selectedDay,
  currentRoutineProducts,
  userId,
  onAddAction,
  onCreateRoutine,
  onActiveClick,
  activeId,
  onActiveDetailBack
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    // Check on mount
    checkScreenSize();

    // Add event listener
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  if (!isOpen) return null;

  // Render mobile bottom sheet
  if (isMobile) {
    switch (type) {
      case 'addProduct':
        return (
          <AddProductBottomSheet
            isOpen={isOpen}
            onClose={onClose}
            onAddProduct={onAddProduct!}
          />
        );
      case 'contactUs':
        return (
          <ContactUsBottomSheet
            isOpen={isOpen}
            onClose={onClose}
            onSend={onSend}
          />
        );
      case 'productDetail':
        return (
          <ProductDetailBottomSheet
            isOpen={isOpen}
            onClose={onClose}
            onBack={onBack}
            product={product!}
            onAddProduct={onAddProductToCabinet}
          />
        );
      case 'addToRoutine':
        return (
          <AddToRoutineBottomSheet
            isOpen={isOpen}
            onClose={onClose}
            onAddProduct={onAddProduct!}
            onAddAction={onAddAction}
            routineType={routineType!}
            selectedDay={selectedDay!}
            currentRoutineProducts={currentRoutineProducts!}
            userId={userId!}
          />
        );
      case 'createRoutine':
        return (
          <CreateRoutineBottomSheet
            isOpen={isOpen}
            onClose={onClose}
            onCreateRoutine={onCreateRoutine!}
          />
        );
      case 'terms':
        return (
          <TermsBottomSheet
            isOpen={isOpen}
            onClose={onClose}
          />
        );
      case 'privacy':
        return (
          <PrivacyBottomSheet
            isOpen={isOpen}
            onClose={onClose}
          />
        );
      case 'activeDetail':
        return (
          <ActiveDetailBottomSheet
            isOpen={isOpen}
            onClose={onClose}
            onBack={onActiveDetailBack}
            activeId={activeId!}
          />
        );
      case 'activeIngredients':
        return (
          <ActiveIngredientsBottomSheet
            isOpen={isOpen}
            onClose={onClose}
            onActiveClick={onActiveClick}
          />
        );
      default:
        return null;
    }
  }

  // Render desktop dialog
  switch (type) {
    case 'addProduct':
      return (
        <AddProductDialog
          isOpen={isOpen}
          onClose={onClose}
          onAddProduct={onAddProduct!}
        />
      );
    case 'contactUs':
      return (
        <ContactUsDialog
          isOpen={isOpen}
          onClose={onClose}
          onSend={onSend}
        />
      );
    case 'productDetail':
      return (
        <ProductDetailDialog
          isOpen={isOpen}
          onClose={onClose}
          onBack={onBack}
          product={product!}
          onAddProduct={onAddProductToCabinet}
        />
      );
          case 'addToRoutine':
        return (
          <AddToRoutineDialog
            isOpen={isOpen}
            onClose={onClose}
            onAddProduct={onAddProduct!}
            onAddAction={onAddAction}
            routineType={routineType!}
            selectedDay={selectedDay!}
            currentRoutineProducts={currentRoutineProducts!}
            userId={userId!}
          />
        );
    case 'createRoutine':
      return (
        <CreateRoutineDialog
          isOpen={isOpen}
          onClose={onClose}
          onCreateRoutine={onCreateRoutine!}
        />
      );
    case 'terms':
      return (
        <TermsDialog
          isOpen={isOpen}
          onClose={onClose}
        />
      );
    case 'privacy':
      return (
        <PrivacyDialog
          isOpen={isOpen}
          onClose={onClose}
        />
      );
    case 'activeIngredients':
      return (
        <ActiveIngredientsDialog
          isOpen={isOpen}
          onClose={onClose}
          onActiveClick={onActiveClick}
        />
      );
    case 'activeDetail':
      return (
        <ActiveDetailDialog
          isOpen={isOpen}
          onClose={onClose}
          onBack={onActiveDetailBack}
          activeId={activeId!}
        />
      );
    default:
      return null;
  }
};

export default ResponsiveDialog;
